// eslint-disable-next-line no-restricted-imports
import { useTheme } from '@emotion/react';
// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { productPhotoMetadata } from '@iheartjane/menu';
import { Box, Button, Flex, Typography } from '@iheartjane/reefer';
import { clsx } from 'clsx';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { monolithPaths as paths } from '@jane/shared/util';

import SvgIcon from '../legacyIcons/legacySvgIcon';
import { DisplayMode, useProductCardContext } from '../productCardProvider';
import { ProductImage } from '../ProductImage';
import { MenuProductCardBackButton } from './backButton';
import { ProductPhotoCorner } from './editView';

import styles from './legacyMenuProductCard.module.css';

const ConfirmationMessage = styled.div({
  position: 'absolute' as const,
  left: 0,
  right: 0,
  top: 100,
  textAlign: 'center',
});

const ProductPhoto = styled.div(
  {
    position: 'absolute' as const,
    top: 0,
    right: 0,
    width: 100,
    overflow: 'hidden',
    height: 100,
    img: {
      objectFit: 'cover',
    },
  },
  ({ theme }) => ({ borderRadius: theme.borderRadius.sm })
);

interface Props {
  height?: number | string;
}

export const MenuProductConfirmationView = ({ height }: Props) => {
  const { appMode, menuProduct, setDisplayMode } = useProductCardContext();
  const navigate = useNavigate();
  const photoMetadata = productPhotoMetadata(menuProduct);

  const theme = useTheme();

  useEffect(() => {
    const timer = setTimeout(() => {
      setDisplayMode(DisplayMode.Product);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Flex
      className={clsx(styles['cardContent'], styles['cardContent__focused'])}
      flexDirection="column"
      height={height}
      justifyContent="space-between"
    >
      <Box px={12} pt={12}>
        <MenuProductCardBackButton
          onClick={() => {
            setDisplayMode(DisplayMode.Product);
          }}
          productName={menuProduct?.name}
        />
      </Box>
      <ProductPhoto>
        <ProductPhotoCorner />
        <ProductImage src={photoMetadata.url} alt={menuProduct?.name || ''} />
      </ProductPhoto>
      <ConfirmationMessage>
        <SvgIcon
          color={theme?.colors.primary.main}
          size={{ width: 32, height: 32 }}
          icon="circleCheckFilled"
        />
        <Typography pt={8} pb={24} variant="body-bold">
          Bag updated!
        </Typography>
      </ConfirmationMessage>
      {(appMode === 'headless' || appMode === 'kiosk') && (
        <Flex px={4} mx={8} mb={16}>
          <Button
            onClick={() => navigate(paths.cart())}
            aria-label="proceed to bag"
            full
            label="Proceed to Bag"
          />
        </Flex>
      )}
    </Flex>
  );
};
